import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.9127 13.6234L21.825 21.4689C21.4771 22.9564 20.1573 24 18.6215 24H7.19902V9.62877L9.26274 2.19121C9.50271 0.607735 11.1465 -0.447969 12.8142 0.187821C13.8101 0.571695 14.398 1.60336 14.398 2.67101V8.41716C14.398 9.07694 14.938 9.59275 15.5979 9.59275H20.7092C22.8329 9.59275 24.3927 11.5601 23.9127 13.6234ZM0 12.016V21.6128C0 22.9324 1.07985 23.988 2.39967 23.988H4.79935V9.59275H2.39967C1.07985 9.59275 0 10.6964 0 12.016Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
